import * as React from 'react';

interface IData {
  d?: IOperation | IPad | IComplications | IEngelClassification;
  fm?: (id: string) => string;
}

export const DataContext: React.Context<IData> = React.createContext({});
